<script setup>
import {onMounted, ref, defineProps, computed, nextTick, watch} from 'vue'

const props = defineProps({
  blue: {
    type: Boolean,
    default: false
  },
  purple: {
    type: Boolean,
    default: false
  }
});
</script>


<template>
  <div class="b" :class="{blue: props.blue, purple: props.purple}">
    <slot/>
  </div>
</template>

<style scoped>

.b {
  background-color: #1E252F;
  border-radius: 10px;
  padding: .6rem 1.6rem;
  display: inline-block;
  transition: all .1s ease; 
}

.b:hover {
  cursor: pointer;
  color: white;
  background-color: #222a35;
}

.b.blue {
  background-color: #4587e7;
  color: white;
}

.b.blue:hover {
  background-color: #5B94E6
}

.b.purple {
  background-color: #a855f7;
  color: white;
}

.b.purple:hover {
  background-color: #b87ff8;
}

</style>
